import React, { Component } from 'react'
import { BrowserRouter, Route, RouteComponentProps, Switch } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Meta } from '../../common'
import CNCDictSublemma from './CNCDictSublemma'
import CNCDictNewSublemmas from './CNCDictNewSublemmas'
import CNCDictCandidates from './CNCDictCandidates'
import CNCDictAddSublemmas from './CNCDictAddSublemmas'
//import CNCDictMatch from './CNCDictMatch'

export interface CNCDictProps extends WithTranslation, RouteComponentProps {
    meta: Meta,
    http: AxiosInstance
}

export const CNCDictCustomComponents = [
    {
        cunit_type: ':cncdict:form',
        type: 'create',
        label: 'New sublemma',
        params: [
            {label: 'Sublemma'}
        ],
        path: '/comp/cncdict/sublemma/new/__%1__'
    },
    {
        cunit_type: ':cncdict:form',
        type: 'create',
        label: 'Adding sublemmas',
        path: '/comp/cncdict/addsublemmas/'
    },
    /*{
        cunit_type: ':cncdict:form',
        type: 'create',
        label: 'List of sublemmas',
        path: '/comp/cncdict/newsublemmas/'
    },*/
    {
        cunit_type: ':cncdict:form',
        type: 'create',
        label: 'List of candidates',
        path: '/comp/cncdict/candidates/'
    },

]

class CNCDict extends Component<CNCDictProps> {
    render() {
        return(
            <>
              <Route path="/comp/cncdict/sublemma/:dir?/:sublemma" render={(props) => <CNCDictSublemma {...props} http={this.props.http} meta={this.props.meta}/>} />
              {/*<Route path="/comp/cncdict/sublemma/:sublemma" render={(props) => <CNCDictSublemma {...props} http={this.props.http} meta={this.props.meta}/>} />*/}
              {/*<Route path="/comp/cncdict/match/:base?/:tagBase?" render={(props) => <CNCDictMatch {...props} http={this.props.http} meta={this.props.meta}/>} />*/}
              {/*<Route path="/comp/cncdict/newsublemmas/*" render={(props) => <CNCDictNewSublemmas {...props} http={this.props.http} meta={this.props.meta}/>} />*/}
              <Route path="/comp/cncdict/candidates/*" render={(props) => <CNCDictCandidates {...props} http={this.props.http} meta={this.props.meta}/>} />
              <Route path="/comp/cncdict/addsublemmas/*" render={(props) => <CNCDictAddSublemmas {...props} http={this.props.http} meta={this.props.meta}/>} />
            </>
        )
    }
}

export default withTranslation()(CNCDict)